import { useAmpliFeatureFlags } from '@tackle-io/tackle-auth-tools';
import { FeatureFlagState } from 'packages/cosell/src/types/enums/FeatureFlags';

/**
 * Hook to get all integration-related feature flags
 */
export const useIntegrationFeatureFlags = () => {
  const featureFlags = useAmpliFeatureFlags();
  const flags = featureFlags?.flags || {};
  return {
    integrationsEnabled:
      flags['cloud-connector-integrations'] === FeatureFlagState.ON,
    awsIntegrationsEnabled:
      flags['cloud-connector-aws-integrations'] === FeatureFlagState.ON,
  };
};

/**
 * Hook to evaluate access to general integrations pages
 */
export const useIntegrationsAccess = () => {
  const { integrationsEnabled } = useIntegrationFeatureFlags();
  return integrationsEnabled;
};

/**
 * Hook to evaluate access to AWS integration pages
 */
export const useAwsIntegrationAccess = () => {
  const { awsIntegrationsEnabled } = useIntegrationFeatureFlags();
  return awsIntegrationsEnabled;
};
